export const lightDarkColor = (color: string, percent: number) => {
  const num = parseInt(color.replace('#', ''), 16)
  const amt = Math.round(2.55 * percent)
  const R = (num >> 16) + amt
  const B = ((num >> 8) & 0x00ff) + amt
  const G = (num & 0x0000ff) + amt

  return `#${(
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
    (G < 255 ? (G < 1 ? 0 : G) : 255)
  )
    .toString(16)
    .slice(1)}`
}

export const opacityPercetColor = (color: string, percent: number) =>
  `${color}${Math.round(percent * 255).toString(16)}`

export const contrastTextColor = (color: string) => {
  const threshold = 130

  const cutHex = (h: string) => {
    return h.charAt(0) == '#' ? h.substring(1, 7) : h
  }
  const hexToR = (h: string) => {
    return parseInt(cutHex(h).substring(0, 2), 16)
  }
  const hexToG = (h: string) => {
    return parseInt(cutHex(h).substring(2, 4), 16)
  }
  const hexToB = (h: string) => {
    return parseInt(cutHex(h).substring(4, 6), 16)
  }

  const hRed = hexToR(color)
  const hGreen = hexToG(color)
  const hBlue = hexToB(color)

  const cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000

  return cBrightness > threshold ? '#505050' : '#FFFFFF'
}
